import { z } from 'zod';
import type {
  ListInboundReceiptsRequest,
  ListInboundReceiptsResponse,
} from './list-inbound-receipts.dto.js';
import { InboundReceiptDetailDtoSchema } from './inbound-receipts-shared.schema.js';
import {
  AttachmentAvailabilityStatusSchema,
  InboundReceiptStatusSchema,
  OfficialComparisonReviewStatusSchema,
} from './inbound-receipts-types.js';

export const ListInboundReceiptsRequestSchema: z.ZodType<ListInboundReceiptsRequest> = z
  .object({
    companyId: z.uuid(),
    stationId: z.uuid().optional(),
    materialId: z.uuid().optional(),
    statuses: z.array(InboundReceiptStatusSchema).optional(),
    availabilityStatuses: z.array(AttachmentAvailabilityStatusSchema).optional(),
    reviewStatuses: z.array(OfficialComparisonReviewStatusSchema).optional(),
  })
  .strict();

export const ListInboundReceiptsResponseSchema: z.ZodType<ListInboundReceiptsResponse> = z
  .object({
    items: z.array(InboundReceiptDetailDtoSchema),
  })
  .strict();
